import React, { Component } from 'react'

export default class FieldGroup extends Component {
    state = {  }
    render() { 
        const { label, children } = this.props
        return ( 
            <div className="flex flex-col justify-center align-top mt-3 mb-10">
                <label className="text-start pl-2 my-2 font-bold " style={{ color:'#00573d'}}>{ label }</label>
                <div className="border px-4 py-0">
                        { children }
                </div>
            </div>
         );
    }
}
